import { IconDefinition } from "./types";

const carBuilding: IconDefinition = {
  iconName: "car-building",
  width: 576,
  height: 512,
  svgPathData:
    "M48 48l288 0 0 63.8 48 0 0-111.8-384 0 0 480 144 0 0-48-96 0 0-384zm96 240l16 0 0-64-64 0 0 64 48 0zM96 96l0 64 64 0 0-64-64 0zm184 63.9l-17.6 0-5.3 16.8-34.7 111.2-30.4 0 0 224 48 0 0-32 288 0 0 32 48 0 0-224-30.4 0-34.7-111.2-5.3-16.8-225.6 0zm248 240l0 32-288 0 0-96 288 0 0 64zm-32.6-112l-222.7 0 25-80 172.7 0 25 80zM312 383.9a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "car-building",
  unicode: 0xf859,
};

export { carBuilding };
